/* AURORA — Selector de packs (vanilla, sin dependencias).
   1) Sincroniza el radio del pack elegido con el input real de variante
      del formulario de compra (mismo mecanismo nativo de carrito del tema).
   2) "Pack pareja" agrega DOS productos reales al carrito en una sola
      llamada a la Cart AJAX API de Shopify (/cart/add.js), porque un
      <form> HTML clásico solo puede enviar una variante por envío. */
(function () {
  'use strict';

  var radios = document.querySelectorAll('.aurora-pack-card__radio');
  var variantInput = document.querySelector('[data-aurora-pack-variant-input]');
  if (radios.length && variantInput) {
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) {
          variantInput.value = radio.dataset.variantId;
        }
      });
    });
  }

  var parejaButton = document.querySelector('[data-aurora-pareja-add]');
  if (parejaButton) {
    parejaButton.addEventListener('click', function () {
      if (parejaButton.disabled) return;
      var menId = parejaButton.dataset.menVariantId;
      var womenId = parejaButton.dataset.womenVariantId;
      if (!menId || !womenId) return;

      var originalText = parejaButton.textContent;
      parejaButton.disabled = true;
      parejaButton.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            { id: menId, quantity: 1 },
            { id: womenId, quantity: 1 }
          ]
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart add failed');
          window.location.href = '/cart';
        })
        .catch(function () {
          parejaButton.disabled = false;
          parejaButton.textContent = originalText;
          window.alert('No pudimos agregar el pack pareja. Probá de nuevo.');
        });
    });
  }
})();
